export const enumViewModePrenotazioni = {
	Month: 1,
	daily: 2,
	AdvancedFilter: 3,
}